// 사업자 일 때 이름, 전화번호는 없어집니다.
export const basicUserInfoConst = [
  {
    title: '프로필',
    name: 'profile',
    content: '',
    isNecessary: true,
    id: 'userProfileUpload',
    disabled: true,
  },
  {
    title: '계정',
    name: 'email',
    content: '',
    isNecessary: true,
    disabled: true,
    max: 50,
  },
  {
    title: '가입 SNS',
    name: 'sns',
    content: '',
    isNecessary: true,
    disabled: true,
  },
  {
    title: '이름',
    name: 'name',
    placeholder: '이름을 입력해주세요.',
    isNecessary: true,
    content: '',
    max: 10,
  },
  {
    title: '닉네임',
    name: 'nickname',
    placeholder: '닉네임을 입력해주세요.',
    isNecessary: false,
    content: '',
    max: 10,
  },
  {
    title: '연락처',
    name: 'phone',
    placeholder: '- 없이 입력해주세요.',
    isNecessary: true,
    content: '',
    max: 13,
  },
  {
    title: '회원 유형',
    name: 'role',
    content: '',
    isNecessary: true,
    disabled: true,
  },
  {
    title: '가입일',
    name: 'createdAt',
    content: '',
    isNecessary: true,
    disabled: true,
  },
  {
    title: '[선택] 개인정보 수집 동의',
    name: 'personalInfoConsent',
    content: false,
    type: 'checkbox',
  },
  {
    title: '[선택] 마케팅 목적의 개인정보 수집 및 이용동의',
    name: 'marketingConsent',
    content: false,
    type: 'checkbox',
  },
  {
    title: '[선택] 광고성 정보 수신 동의',
    name: 'adsConsent',
    content: false,
    type: 'checkbox',
  },
  {
    title: 'INAVI Maps 사이트를 어떻게 알고 방문하셨나요?',
    name: 'inflowChannel',
    type: 'radio',
    content: '',
  },
];
